module.exports = __webpack_public_path__ + "static/img/CgoRC2OSsVaAPPCgABuXqX2_bj4050.e360d14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CgoRC2OSsVaAPPCgABuXqX2_bj4050.jpg
// module id = PBXq
// module chunks = 73